import { useState } from "react";

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <header className="header">
        <div className="container">
          <h1 className="logo">Nirajan</h1>

          <nav className="nav">
            <a href="#home">Home</a>
            <a href="#about">About</a>
            <a href="#projects">Projects</a>
            <a href="#contact">Contact</a>
          </nav>

          <button className="menu-btn" onClick={() => setOpen(!open)}>
            ☰
          </button>
        </div>

        {open && (
          <div className="mobile-nav">
            <a href="#home">Home</a>
            <a href="#about">About</a>
            <a href="#projects">Projects</a>
            <a href="#contact">Contact</a>
          </div>
        )}
      </header>

      {/* Inline CSS */}
      <style>{`
        .header {
          width: 100%;
          background: white;
          box-shadow: 0 2px 10px rgba(0,0,0,0.1);
          position: fixed;
          top: 0;
          z-index: 1000;
        }
        .container {
          max-width: 1200px;
          margin: auto;
          padding: 16px 24px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .logo {
          font-size: 24px;
          font-weight: bold;
          color: #1f2933;
        }
        .nav {
          display: flex;
          gap: 32px;
        }
        .nav a {
          text-decoration: none;
          color: #374151;
          font-weight: 500;
        }
        .nav a:hover {
          color: #2563eb;
        }
        .menu-btn {
          display: none;
          font-size: 24px;
          background: none;
          border: none;
          cursor: pointer;
        }
        .mobile-nav {
          display: none;
          flex-direction: column;
          padding: 12px 24px 20px;
          background: white;
        }
        .mobile-nav a {
          padding: 10px 0;
          text-decoration: none;
          color: #374151;
          font-weight: 500;
        }
        @media (max-width: 768px) {
          .nav {
            display: none;
          }
          .menu-btn {
            display: block;
          }
          .mobile-nav {
            display: flex;
          }
        }
      `}</style>
    </>
  );
}
